// extracted by mini-css-extract-plugin
module.exports = {"imgBg":"Torcher_imgBg__3YNmf","nickName":"Torcher_nickName__2ybxT","no":"Torcher_no__3WCCT","back":"Torcher_back__2iojA"};